//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'group',
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number]
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/group/index.vue